import React, { useRef, ReactInstance, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { connect } from 'react-redux'
import Header from '../../Header'
import Footer from '../../Footer'
import { setUIForwardAction, setUIBackwardsAction } from '../../../actions'
import { UI } from '../../../constants/ui'
import SeaWayBill from '../../SeaWayBill'
import VehicleCard from '../../VehicleCard'
import ReactToPrint from '../../ReactToPrint'
import { AppState } from '../../../reducers'
import './alreadyCheckedIn.less'
import { isVehicleBoardingCardNeedReducer } from '../../../reducers/terminal'
import { getMode } from '../../../hooks/mode'

class EmptyComponent extends React.Component {
  render() {
    return null
  }
}

const mapDispatchToProps = {
  setUIForward: setUIForwardAction,
  setUIBackwards: setUIBackwardsAction,
}
type DispatchProps = typeof mapDispatchToProps

const mapStateToProps = (state: AppState) => ({
  reservation: state.reservation.originReservation,
  terminal: state.terminal.terminal,
  isVehicleBoardingCardNeed: isVehicleBoardingCardNeedReducer(state),
})

type StateProps = ReturnType<typeof mapStateToProps>
type Props = DispatchProps & StateProps

const Component: React.FC<Props> = ({
  setUIForward,
  setUIBackwards,
  reservation,
  terminal,
  isVehicleBoardingCardNeed,
}: Props) => {
  const { t } = useTranslation()
  const mode = getMode()

  const ele: ReactInstance = new EmptyComponent({})
  const seaWayBillRef = useRef<any>(null)
  const buttonSWBRef = useRef<HTMLButtonElement | null>(null)
  const onCurrentSWB = () => (seaWayBillRef.current ? seaWayBillRef.current : ele)
  const [isActivePrintButton, toggleActivityOfPrintButton] = useState(true)
  const vehicleCardRef = useRef<any>(null)
  const buttonVehicleCardRef = useRef<HTMLButtonElement | null>(null)
  const onCurrentVehicleCard = () => (vehicleCardRef.current ? vehicleCardRef.current : ele)

  const onAfterSWBPrint = () => {
    setUIForward(UI.MAIN)
  }
  const onAfterVehicleCardPrint = () => {
    setUIForward(UI.PRINT_SWB)
  }

  const onClickFakePrintButton = () => {
    toggleActivityOfPrintButton(false)
    if (isVehicleBoardingCardNeed) {
      onAfterVehicleCardPrint()
    } else {
      onAfterSWBPrint()
    }
  }

  const onClickPrintButton = () => {
    toggleActivityOfPrintButton(false)
    if (isVehicleBoardingCardNeed) {
      buttonVehicleCardRef.current && buttonVehicleCardRef.current.click()
    } else {
      buttonSWBRef.current && buttonSWBRef.current.click()
    }
  }

  if (!reservation) {
    return null
  }

  return (
    <React.Fragment>
      <Header back={() => setUIBackwards(UI.MAIN)} />
      <div className="alreadyCheckedIn">
        <div className="alreadyCheckedIn-title">{t('alreadyCheckedInTitle')}</div>
        <div className="alreadyCheckedIn-text">{t('alreadyCheckedInMessage')}</div>
        <div className="alreadyCheckedIn-buttons">
          <button className="main-button to-home-button" onClick={() => setUIBackwards(UI.MAIN)}>
            {t('no')}
          </button>
          <button className="main-button next" onClick={onClickPrintButton} disabled={!isActivePrintButton}>
            {t('yes')}
          </button>
        </div>

        <div className="sea-way-template">
          <button className="fake-button-for-print" onClick={onClickFakePrintButton}></button>
          <ReactToPrint
            trigger={() => <button ref={buttonSWBRef} className="hidden-button" />}
            content={onCurrentSWB}
            copyStyles
            onAfterPrint={onAfterSWBPrint}
          />
          <div ref={seaWayBillRef}>
            <SeaWayBill reservation={reservation} terminal={terminal} />
          </div>
        </div>
        <div className="vehicle-card-template">
          <ReactToPrint
            trigger={() => <button ref={buttonVehicleCardRef} className="hidden-button" />}
            content={onCurrentVehicleCard}
            copyStyles
            onAfterPrint={onAfterVehicleCardPrint}
          />
          <div ref={vehicleCardRef}>
            <VehicleCard reservation={reservation} />
          </div>
        </div>
      </div>
      <Footer />
    </React.Fragment>
  )
}

export default connect(mapStateToProps, mapDispatchToProps)(Component)
